const baseURL =
  process.env.REACT_APP_NODE_ENV === "development"
    ? "http://localhost:3001/api"
    : "https://us-central1-mki-legal-family-master.cloudfunctions.net/app/api";

const sendQuoteNotification = async (data: any) => {
  try {
    const rawResponse = await fetch(`${baseURL}/send-quote-enquiry-notification`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    await rawResponse.json();
    if (window && (window as any)?.dataLayer) {
      (window as any).dataLayer.push({
        event: "FormSubmit",
        url: window.location.href
      });
    }
  } catch (error: any) {
    console.error("error", error);
    throw Error(error);
  }
};

export const NotificationService = {
  sendQuoteNotification
};
